import { Button, Card } from '@/components/generic';

const Service = ({
  title,
  description,
  cta,
  href,
}: {
  title?: string | undefined;
  description?: string | undefined;
  cta?: string | undefined;
  href?: string | undefined;
}) => {
  return (
    <Card classHead='!pl-3' title={title || ''} className='m-0'>
      <div className='p-3 pt-0'>
        <div className='flex items-center mb-8'>
          <div className='grow text-body-2 font-medium text-t-secondary [&_a]:text-[0.9375rem] [&_a]:leading-[1.5rem] [&_a]:font-semibold [&_a]:text-t-primary [&_a]:transition-colors [&_a]:hover:text-shade-05 max-2xl:pl-3 max-lg:pl-5 dark:[&_a]:hover:text-shade-08/90'>
            {description}
          </div>
        </div>
        <Button
          className='w-full'
          href={href?.toString() || '/'}
          as='link'
          isStroke
        >
          {cta}
        </Button>
      </div>
    </Card>
  );
};

export default Service;
